import axios from '@nextcloud/axios';
import { showError } from '@services/utils/dialog';

import { translate as t } from '@services/l10n';
import { API } from '@services/API';
import * as nativex from '@native';

import type { IPhoto } from '@typings';

/**
 * Download files
 */
export async function downloadFiles(fileIds: number[], title?: string) {
  if (!fileIds.length) {
    return;
  }

  if (fileIds.length === 1) {
    return downloadFromUrl(API.DOWNLOAD_ONE(fileIds[0]), title);
  }

  const res = await axios.post(API.DOWNLOAD_REQUEST(), { files: fileIds });
  if (res.status !== 200 || !res.data.handle) {
    showError(t('memories', 'Failed to download files'));
    return;
  }

  downloadWithHandle(res.data.handle, title);
}

/** Get URL to download one file (e.g. for video streaming) */
export function getDownloadLink(photo: IPhoto) {
  return API.STREAM_FILE(photo.fileid);
}

/**
 * Download files with a download handle
 * @param handle Download handle
 * @param title Optional label for the native completion notification
 */
export function downloadWithHandle(handle: string, title?: string) {
  return downloadFromUrl(API.DOWNLOAD_FILE(handle), title);
}

/**
 * Download files from a URL.
 * @param url URL to download from
 * @param title Optional label for the native completion notification
 */
export function downloadFromUrl(url: string, title?: string) {
  // Hand off to download manager (absolute URL)
  if (nativex.has()) return nativex.downloadFromUrl(url, title);

  // Fallback to browser download
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  document.body.appendChild(link);
  link.click();
  link.remove();
}
